import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import {UNREAD_TRIGGER_OFFSET} from '@/hooks/useLastSeenMessage';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.small};
`;

export const LastSeen = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.xSmall};
  scroll-margin-top: calc(${sizes.small} + ${UNREAD_TRIGGER_OFFSET}px);
  color: ${colors.blue4};
  white-space: nowrap;
`;

export const LastSeenLine = styled.div`
  width: 100%;
  height: 1px;
  background: currentColor;
`;
